const employee = {
  id: 'whatever',
  clientKey: 'client',
  emailAddress: 'test@ignitesales.com',
  firstName: 'Test',
  lastName: 'User',
};

let notes = [
  {
    id: Math.random(),
    content:
      'Once upon a time, there was a man. This man liked to write notes, so he wrote the longest note you could possibly imagine. This note was SOOO long it went past the scroll bars and wrapped around the screen again and again, and you know what, it was ok. Perfectly fine.\nNo issues whatsoever.',
    timestamp: new Date(),
    employee,
  },
];

const NoteService = {
  addNote: async (content) => {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        const note = {
          id: Math.random(),
          content,
          timestamp: new Date(),
          employee,
        };
        notes.push(note);
        resolve(note);
      }, 250);
    });
  },

  updateNote: async (note) => {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        let found = null;
        notes.forEach((n) => {
          if (note.id === n.id) {
            n.id = note.id;
            n.content = note.content;
            n.timestamp = new Date();
            n.employee = note.employee;
            found = n;
          }
        });
        if (found) {
          resolve(found);
        }
      }, 250);
    });
  },

  retrieveNotes: async () => {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        notes.forEach((n) => (n.editing = false));
        resolve(notes);
      }, 250);
    });
  },

  removeNote: async (note) => {
    return new Promise((resolve) => {
      window.setTimeout(() => {
        notes = notes.filter((n) => note.id !== n.id);
        resolve({
          status: 'success',
        });
      }, 250);
    });
  },
};

export default NoteService;
